export function createElementFromHTML(htmlString: string, noTrim?: boolean) {
  const span = document.createElement('span')
  span.innerHTML = noTrim ? htmlString : htmlString.trim()
  return span
}
